module.exports = __webpack_public_path__ + "static/img/down_bg.a6cec2fd.png";